import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/adminNav.css";
import Logo from "../assets/logo.png";

const DropdownMenu = ({ title, index, openIndex, setOpenIndex, children }) => {
  const isOpen = openIndex === index;
  const toggleDropdown = () => setOpenIndex(isOpen ? null : index);
  return (
    <div className={`dropdown-menu ${isOpen ? "open" : ""}`}>
      <p onClick={toggleDropdown} className="dropdown-title">
        {title}
        <span className={`arrow ${isOpen ? "rotate" : ""}`}>▼</span>
      </p>
      {isOpen && <ul className="dropdown-list">{children}</ul>}
    </div>
  );
};

function getStoredAdmin() {
  try {
    const raw = localStorage.getItem("nissi_admin");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const AdminNav = () => {
  const navigate = useNavigate();

  // read the full profile object { id, username, company_name, num_licenses, num_users }
  const [admin, setAdmin] = useState(getStoredAdmin());

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    // keep in sync across tabs/windows
    const onStorage = (e) => {
      if (e.key === "nissi_admin") {
        setAdmin(getStoredAdmin());
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // (optional) redirect to login if no admin in storage
  // useEffect(() => {
  //   if (!admin) navigate("/login");
  // }, [admin, navigate]);

  const handleLogout = () => {
    localStorage.removeItem("nissi_admin"); 
    localStorage.removeItem("username");    
    navigate("/admin");
  };

  return (
    <div className={`admin-nav-container ${isMenuOpen ? "open" : ""}`}>
      {/* Top Header (Mobile) */}
      <div className="admin-nav-header">
        <img src={Logo} alt="logo" className="school--logo-mobile" />
        <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>☰</button>
      </div>

      {/* Sidebar */}
      <div id="nav-container" className={`${isMenuOpen ? "show" : ""}`}>
        <div className="img-flex">
          <div className="logo-container">
            <img src={Logo} alt="logo" className="school--logo" />
          </div>
        </div>

        <div className="user-info">
          <p>
            User: <b>{admin?.username || "-"}</b>
          </p>
          {/* Optional: show company or modules */}
          <p>Company: <b>{admin?.company_name || "-"}</b></p>
          {/* <p>Modules: <b>{({1:"Vehicle",2:"Inventory",3:"Both"}[String(admin?.num_licenses)] || "—")}</b></p> */}
        </div>

        <div className="content-left">
          <ul>
            <DropdownMenu
              title="Control Panel SetUp"
              index={0}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              <Link to="/admin/cd"><li>Company Details</li></Link>
              <Link to="/admin/admin_members_list"><li>Members List</li></Link>
              <Link to="/admin/staff_category_list"><li>Category Listing</li></Link>
              <Link to="/admin/flashNewsEntry"><li>Flash News</li></Link>
              <Link to="/admin/admin_filemanager"><li>File Manager</li></Link>
              <Link to="/admin/branchMasterView"><li>Branch</li></Link>
              <Link to="/admin/admin_Menu"><li>Menu</li></Link>
              <Link to="/admin/menu_orders"><li>Menu Orders</li></Link>
            </DropdownMenu>
          </ul>
        </div>

        <div className="nav_buttons">
          <button onClick={handleLogout} className="logout">Logout</button>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
